var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sbd-avatar",class:'ivu-avatar-'+_vm.shape,style:({ width:_vm.width + 'px',height:_vm.height + 'px',lineHeight:_vm.height + 'px'})},[_c('img',{class:{'sbd-height-auto':_vm.isAuto},attrs:{"src":_vm.url ? _vm.url : _vm.defaultUrl,"width":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cb086e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/model/avatar/avatar.vue
// module id = 17
// module chunks = 0